import { __assign, __extends } from "tslib";
import _get from 'lodash/get';
import { SubReducerBase, } from './reducers';
var UpdateUnreadChatroomsSubReducer = /** @class */ (function (_super) {
    __extends(UpdateUnreadChatroomsSubReducer, _super);
    function UpdateUnreadChatroomsSubReducer(config) {
        return _super.call(this, config) || this;
    }
    UpdateUnreadChatroomsSubReducer.prototype.reduce = function (state, action) {
        var unreadChatroomIds = this.extractUnreadChatroomIds(action);
        if (unreadChatroomIds.length > this.config.maxTrackableUnreads) {
            return this.reduceToTrackingOverflowState();
        }
        return this.reduceUnreadsIdsModification(state, unreadChatroomIds);
    };
    UpdateUnreadChatroomsSubReducer.prototype.extractUnreadChatroomIds = function (action) {
        return _get(action, ['data', 'chatroomIds'], []);
    };
    UpdateUnreadChatroomsSubReducer.prototype.reduceUnreadsIdsModification = function (state, unreadChatroomIds) {
        var modification = this.parseUnreadChatroomIdsArray(unreadChatroomIds);
        return __assign(__assign(__assign({}, state), modification), { resyncCountdown: undefined });
    };
    return UpdateUnreadChatroomsSubReducer;
}(SubReducerBase));
export default UpdateUnreadChatroomsSubReducer;
var UpdateUnreadChatroomsFromPayloadSubReducer = /** @class */ (function (_super) {
    __extends(UpdateUnreadChatroomsFromPayloadSubReducer, _super);
    function UpdateUnreadChatroomsFromPayloadSubReducer(config) {
        return _super.call(this, config) || this;
    }
    UpdateUnreadChatroomsFromPayloadSubReducer.prototype.extractUnreadChatroomIds = function (action) {
        return _get(action, ['payload', 'chatroomIds'], []);
    };
    return UpdateUnreadChatroomsFromPayloadSubReducer;
}(UpdateUnreadChatroomsSubReducer));
export { UpdateUnreadChatroomsFromPayloadSubReducer };
